<div class="sh-page-template__main__wrapper">
  <div class="sh-page-template__main__content">
    <div class="sh-template-stack">
      <sh-page-header class="sh-template-stack__item" [title]="'notifications.title' | translate"></sh-page-header>

      <digihaven-table-header
        class="sh-template-stack__item"
        [title]="tableHeaderWithCount$ | async"
        [sortOptions]="SORT_OPTIONS"
        (sortInfoChanged)="onSortInfoChange($event)"
      ></digihaven-table-header>
      <div class="sh-template-stack__item">
        <div class="sh-card-table-wrapper">
          @if (selectedItemsCount > 0) {
            <digihaven-action-bar
              class="sh-sticky-header"
              [totalItemsCount]="(notificationList$ | async)?.length"
              [selectedItemsCount]="selectedItemsCount"
              (shouldSelectAll)="onSelectAll($event)"
              [actionItems]="actionBarActionItems"
              [darkMode]="true"
            ></digihaven-action-bar>
          }

          <table class="sh-card-table" id="notifications-overview">
            <thead class="sh-card-table__header--context-actions">
              <tr>
                <th scope="col" class="sh-card-table__col--small">
                  <input
                    type="checkbox"
                    id="series-list-select-all-toggle"
                    class="sh-checkbox -sh-vertical-align"
                    [formControl]="selectAllFormControl"
                    />
                </th>
                <th scope="col" width="150">{{ "notifications.table.columns.date" | translate }}</th>
                <th scope="col" width="600">{{ "notifications.table.columns.name" | translate }}</th>
                <th scope="col" width="250">{{ "notifications.table.columns.notification" | translate }}</th>
                <th scope="col" width="50"></th>
              </tr>
            </thead>
            <tbody>
              @if (loading$ | async) {
                <tr>
                  <td [colSpan]="COLUMN_COUNT">{{ "ui.loading" | translate }}</td>
                </tr>
              }

              @if (!(loading$ | async) && !(error$ | async) && (notificationList$ | async)?.length === 0) {
                <tr>
                  <td [colSpan]="COLUMN_COUNT">{{ "notifications.messages.empty-list" | translate }}</td>
                </tr>
              }

              @if (error$ | async) {
                <tr class="sh-card-table__row--error">
                  <td [colSpan]="COLUMN_COUNT">{{ "notifications.messages.failed-to-fetch" | translate }}</td>
                </tr>
              }

              @if (!(loading$ | async) && !(error$ | async) && (notificationList$ | async)?.length > 0) {
                @for (notification of notificationList$ | async; track notification; let row = $index) {
                  <tr [class.-sh-emphasise]="notification.New">
                    <td>
                      <input
                        class="sh-checkbox"
                        type="checkbox"
                        [checked]="selectedIndexRecordsMap.get(row)"
                        (click)="selectRow(row, $event.target.checked, notification)"
                        />
                    </td>
                    <td>{{ notification.SentOn | readableDate }}</td>
                    <th scope="row" [id]="notification.Id">
                      @if (!(notification | isDeleteNotification)) {
                        <a
                          class="sh-list-row-title sh-link"
                          [shNavigationLink]="getNavigationLink(notification)"
                          >
                          <h3 class="sh-list-row-title__title -sh-wrap">{{ notification.Body }}</h3>
                        </a>
                      } @else {
                        {{ notification.Body }}
                      }
                    </th>
                    <td>{{ notification.Title }}</td>
                    <td>
                      <button
                        type="button"
                        class="sh-button--ghost sh-pure-icon-button"
                        (click)="deleteNotification(notification)"
                        aria-label="close"
                        >
                        <svg sh-icon class="sh-icon sh-icon-button__icon" aria-hidden="true" [name]="'close'"></svg>
                      </button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
      @if (pagedResult$ | async; as pagedResult) {
        <sh-pagination
          class="sh-template-stack__item"
          [paginationInfo]="pagedResult"
          [previousPageMsg]="'components.pagination.previous' | translate"
          [nextPageMsg]="'components.pagination.next' | translate"
          [perPageMsg]="'components.pagination.per-page' | translate"
          (paginationInfoChanged)="paginationInfoChanged($event)"
        ></sh-pagination>
      }
    </div>
  </div>
</div>
